export default "/images/vendor/flag-icon-css/flags/4x3/se.svg?5a79810b09a06d579eadd3ad923d6df8";